module.exports = __webpack_public_path__ + "static/media/sebastien-gabrieles.d1b7ea8b.jpg";